/* eslint-disable prefer-regex-literals */
export const DIGITS_REGEX = /^\d+$/;
export const DIGITS_WITH_DOT = /^\d+(\.\d+)?$/;
export const LETTER_REGEX = /^[a-zA-Z]+$/;
export const LETTER_REGEX_WITH_SPACE = /^[a-zA-Z\s]+$/;
export const LATIN_LETTER_REGEX = /^[A-Za-zÀ-ž .‘’'-]*$/;
export const LATIN_LETTER_WITH_NUMBERS_REGEX = /^[A-Za-zÀ-ž0-9 .\\/'‘’-]*$/;
export const LATIN_LETTER_WITH_COMMA_REGEX = /^[A-Za-zÀ-ž0-9 ,.\\/'‘’-]*$/;
export const LATIN_LETTER_EXTENDED_WITH_COMMA_REGEX =
  /^[A-Za-zÀ-ÿÀ-žƏəİıĞğŞşÜüÖöÇçÄäßẞҰұҚқӘәҒғӨөҺһҢң0-9 ,.\\/'‘’-]*$/;
export const LATIN_LETTER_EXTENDED_WITH_WITH_SPECIAL_CHARS =
  /^[A-Za-zÀ-ÿÀ-žƏəİıĞğŞşÜüÖöÇçÄäßẞҰұҚқӘәҒғӨөҺһҢң0-9\s,.#\\/'‘’-]*$/;
export const EMAIL_REGEX =
  /^[a-zA-Z0-9._%+-]+@[^.][a-zA-Z0-9.-]*\.[a-zA-Z]{2,}$/;
export const ONLY_CYRILLIC = /^[а-яА-ЯёЁєЄґҐіІїЇ']+$/;
export const IS_NOT_CYRILLIC = /^[^а-яА-ЯёЁєЄґҐіІїЇ']*$/;
export const ONLY_LETTERS_REGEX = new RegExp('^\\p{L}+(-\\p{L}+)*$', 'u');
export const NO_RULE_REGEX = /^.*$/;

export const VALIDATION_RULE_LATIN = 'is-latin';
export const VALIDATION_RULE_LATIN_WITH_NUMBERS = 'is-latin-with-numbers';
export const VALIDATION_RULE_LATIN_WITH_COMMA = 'is-latin-with-coma';
export const VALIDATION_RULE_LATIN_EXTENDED_WITH_COMMA =
  'is-latin-extended-with-coma';
export const VALIDATION_RULE_LATIN_EXTENDED_WITH_SPECIAL_CHARS =
  'is-latin-with-special-chars';
export const VALIDATION_RULE_IS_NOT_CYRILLIC = 'is-not-cyrillic';
export const VALIDATION_RULE_ONLY_LETTERS = 'only-letters';
export const VALIDATION_RULE_ONLY_DIGITS = 'only-digits';
export const VALIDATION_RULE_DIGITS_WITH_DOT = 'digits-with-dot';
export const NO_VALIDATION_RULE = 'no-rule';
